var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useDlqIgnoreRulesApi } from '../../hooks';
import { ErrorText, Loading } from '../../components';
import { Show } from './show';
import { Form } from './form';
export const DlqIgnoreRules = (rulesType) => () => {
    const _a = useDlqIgnoreRulesApi(rulesType), { state } = _a, props = __rest(_a, ["state"]);
    switch (state.view) {
        case 'LOADING':
            return props.error ? React.createElement(ErrorText, null, props.error.message) : React.createElement(Loading, null);
        case 'SHOW':
            return React.createElement(Show, Object.assign({ state: state }, props));
        case 'NEW':
            return (React.createElement("div", null,
                React.createElement("h2", null, "New Rule"),
                React.createElement(Form, Object.assign({}, props, { info: state.info }, props.actions, { ignoreRule: state.selected }))));
        default:
            throw new Error(`unexpected view: ${state.view}`);
    }
};
//# sourceMappingURL=index.js.map